import {defineStore} from 'pinia';

import {fetchWrapper} from '@/helpers/fetch-wrapper';

const baseUrl = `${process.env.VUE_APP_API_URL}/user/advocate/patients`;

export const useUserAdvocatePatientStore = defineStore({
    id: 'userAdvocatePatient',
    state: () => ({
        userAdvocatePatients: [],
        userAdvocatePatient: {},
        userExercises: [],
        userFiles: [],
        userSurveys: [],
        userInstructions: [],
        userForms: [],
        userSessions: [],
    }),
    actions: {
        async fetchAllPatients() {
            const accountId = JSON.parse(localStorage.getItem('user')).patient_account.id;
            const response = await fetchWrapper.get(`${baseUrl}` + '?account_id=' + accountId, null);
            this.userAdvocatePatients = response.data;
        },

        async fetchOnePatient(userId) {
            const accountId = JSON.parse(localStorage.getItem('user')).patient_account.id;
            const response = await fetchWrapper.get(`${baseUrl}/` + Number(userId) +"?account_id=" + accountId, null);
            this.userAdvocatePatient = response.data;
        },

        async fetchForms(userId) {
            const accountId = JSON.parse(localStorage.getItem('user')).patient_account.id;
            const response = await fetchWrapper.get(`${baseUrl}/` + userId + '/forms' + "?account_id=" + accountId, null);
            this.userForms = response.data;
        },

        async fetchSessions(userId) {
            const accountId = JSON.parse(localStorage.getItem('user')).patient_account.id;
            const response = await fetchWrapper.get(`${baseUrl}/` + userId + '/sessions' + "?account_id=" + accountId, null);
            this.userSessions = response.data;
        },

        async fetchExercises(userId) {
            const accountId = JSON.parse(localStorage.getItem('user')).patient_account.id;
            const response = await fetchWrapper.get(`${baseUrl}/` + userId + '/exercises' + "?account_id=" + accountId, null);
            this.userExercises = response.data;
        },

        async fetchSurveys(userId) {
            const accountId = JSON.parse(localStorage.getItem('user')).patient_account.id;
            const response = await fetchWrapper.get(`${baseUrl}/` + userId + '/exercises' + "?account_id=" + accountId, null);
            this.userSurveys = response.data;
        },

        async fetchInstructions(userId) {
            const accountId = JSON.parse(localStorage.getItem('user')).patient_account.id;
            const response = await fetchWrapper.get(`${baseUrl}/` + userId + '/instructions' + "?account_id=" + accountId, null);
            this.userInstructions = response.data;
        },

        async fetchFiles(userId) {
            const accountId = JSON.parse(localStorage.getItem('user')).patient_account.id;
            const response = await fetchWrapper.get(`${baseUrl}/` + userId + '/files' + "?account_id=" + accountId, null);
            this.userFiles = response.data;
        },
    }
});
